import React, {Component} from 'react';
import * as Layout from './layout/layout';
import * as Page from './pages';
import {BrowserRouter, Redirect, Route, Switch} from 'react-router-dom'
import {connect} from 'react-redux';
import * as ClientActions from "./actions/ClientActions";
import {getBasePath, isAuthenticated} from "./firebase";
import * as ProjectActions from "./actions/ProjectActions";
import * as TaskActions from "./actions/TaskActions";
import * as TeamActions from "./actions/TeamActions";
import * as UserActions from "./actions/UserActions";
import Loading from "./components/Loading";
import ReactGA from "react-ga";

// var pendingRedirect;

const PrivateRoute = ({ component: Component, ...rest }) => {
    const TrackedComponent = (props) => {
        ReactGA.pageview(window.location.pathname + window.location.search);
        return <Component {...props}/>
    };
    return (
        <main className="main-container" id="main-container">
            <section>
                <div className="container container-md">
                    <Route {...rest} render={props => (
                        isAuthenticated() === undefined ? (
                            <Loading loading={true} center/>
                        ) : (
                            isAuthenticated() ? (
                                <TrackedComponent {...props}/>
                            ) : (
                                <Redirect to={{
                                    pathname: '/sign-in',
                                    state: {from: props.location}
                                }}/>
                            )
                        )
                    )}/>

                </div>
            </section>
        </main>
    );
};

class App extends Component {
    constructor() {
        super();
        this.state = {
            fetched: false,
        }
    }

    componentWillMount() {
        this.initialLoad();
    }

    componentWillReceiveProps(nextProps) {
        this.initialLoad(nextProps);
    }

    initialLoad(props) {
        props = props || this.props;
        props.user && getBasePath() && props.loadAllClientsAndProjects();
    }

    render() {
        return <BrowserRouter>

            <div className="layout-container">
                <Layout.Navbar user={this.props.user} setActiveUser={user => this.props.setActiveUser(user)}/>

                <Switch>
                    <PrivateRoute exact path="/" component={Page.AddEditEntryPage}/>
                    <PrivateRoute exact path="/entries/:entry_id" component={Page.AddEditEntryPage}/>

                    <PrivateRoute exact path="/clients/add" component={Page.AddEditClientPage}/>
                    <PrivateRoute exact path="/clients/:client_id/edit" component={Page.AddEditClientPage}/>

                    <PrivateRoute exact path="/projects/add" component={Page.AddEditProjectPage}/>
                    <PrivateRoute exact path="/projects/add/client/:client_id" component={Page.AddEditProjectPage}/>
                    <PrivateRoute exact path="/projects" component={Page.ProjectsPage}/>
                    <PrivateRoute exact path="/projects/:project_id/edit" component={Page.AddEditProjectPage}/>
                    <PrivateRoute path="/projects/:project_id" component={Page.ProjectPage}/>

                    <PrivateRoute path="/reporting" component={Page.ReportingPage}/>

                    <PrivateRoute path="/tasks/:project_id/task/:task_id" component={Page.TasksPage}/>
                    <PrivateRoute path="/tasks/:project_id" component={Page.TasksPage}/>

                    <PrivateRoute path="/team" component={Page.TeamPage}/>
                    <PrivateRoute path="/add-team-member" component={Page.AddTeamMemberPage}/>
                    <PrivateRoute path="/upgrade" component={Page.UpgradePage}/>

                    <PrivateRoute path="/user" component={Page.UserPage}/>
                    <PrivateRoute exact path="/cancel" component={Page.CancelPage}/>
                    <PrivateRoute exact path="/feedback" component={Page.FeedbackPage}/>
                    <PrivateRoute path="/test" component={Page.TestPage}/>

                    <Route path="/sign-in" component={Page.SignInPage}/>
                    <Route path="/new-team" component={Page.NewTeamPage}/>
                    <Route path="/team-invite/team/:team/nonce/:nonce" component={Page.TeamInvitePage}/>


                    <Route component={Page.ErrorPage}/>
                    {/*<Route component={Page.PublicWebsitePage}/>*/}
                </Switch>
            </div>
        </BrowserRouter>;
    }
}

export default connect(state => ({
    user: state.users.active,
}), dispatch => ({
    loadAllClientsAndProjects: () => {
        dispatch(ClientActions.fetchClientsIfNeeded("initial"));
        dispatch(ProjectActions.fetchProjectsIfNeeded("initial"));
        dispatch(TaskActions.fetchTasksIfNeeded(null, "initial"));
        dispatch(TeamActions.fetchTeamIfNeeded());
        dispatch(UserActions.fetchUsersIfNeeded());
    },
    setActiveUser: user => dispatch(UserActions.setActiveUser(user))
}))(App);



// WEBPACK FOOTER //
// ./src/App.js